(function() {
  if (!window.location.pathname.includes('/products/hangout-monodoses')) return;

  const MIN = 6;

  function fixQty() {
    document.querySelectorAll('input[name="quantity"]').forEach(function(input) {
      input.min = MIN;
      if (!input.dataset.fixed) {
        input.dataset.fixed = '1';
        if (parseInt(input.value) < MIN) input.value = MIN;
        input.addEventListener('change', function() {
          if (parseInt(this.value) < MIN || isNaN(parseInt(this.value))) this.value = MIN;
        });
        input.addEventListener('blur', function() {
          if (parseInt(this.value) < MIN || isNaN(parseInt(this.value))) this.value = MIN;
        });
      }
    });

    document.querySelectorAll('.quantity__button, [aria-label*="ecrease"], [aria-label*="enos"], [aria-label*="eduzir"]').forEach(function(btn) {
      if (btn.dataset.guardado) return;
      btn.dataset.guardado = '1';
      btn.addEventListener('click', function() {
        setTimeout(function() {
          document.querySelectorAll('input[name="quantity"]').forEach(function(input) {
            if (parseInt(input.value) < MIN) input.value = MIN;
          });
        }, 50);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', fixQty);
  new MutationObserver(fixQty).observe(document.documentElement, { childList: true, subtree: true });
})();